import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdminService } from 'src/app/admin/services/admin.service';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';

@Component({
  selector: 'app-payment-receipt',
  templateUrl: './payment-receipt.component.html',
  styleUrls: ['./payment-receipt.component.scss']
})
export class PaymentReceiptComponent implements OnInit {
  amountApprove: any = "";
  rejectReason = "";
  showApproveCard: boolean = false;
  showRejectCard: boolean = false;
  userId: any;
  receiptLink: any;
  imgLink: any;
  facility_name: any;
  approvalPending: boolean = false;
  paymentRemark = '';
  payment_id: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data, private adminService: AdminService, private location: Location, public dialogRef: MatDialogRef<PaymentReceiptComponent>) {
    console.log('data inside dialog', data,);
    this.userId = data[0]?.id;
    this.payment_id = data[1]?.id
    this.facility_name = data[0]?.facility_name;
    this.receiptLink = data[1]?.payment_reciept.split(",");
    this.approvalPending = data[1]?.status == "1" ? true : false;
  }

  ngOnInit(): void {
    console.log('receiptLink Length', this.receiptLink?.length);
  }

  submitApproveAmount() {
    // console.log('approve', this.amountApprove);

    let payload = {
      user_id: this.userId,
      payment_id: this.payment_id,
      status: "2",
      paid_amount: this.amountApprove,
      remarks: this.paymentRemark,
    }

    // console.log(this.amountApprove, this.amountApprove.toString().substring(0, 1));

    if (this.amountApprove !== "" && this.amountApprove !== undefined && this.amountApprove !== null) {
      if (this.amountApprove?.toString()?.substring(0, 1) == '-') {
        Swal.fire('Error', 'Approve amount never be negative', 'error');
        this.amountApprove = "";
      } else {
        this.adminService.paymentUpdate(payload).subscribe((res: any) => {
          Swal.fire('Success', 'Amount Successfully Approved', 'success').then(() => {
            this.showRejectCard = false;
            this.showApproveCard = false;
            this.amountApprove = "";
            this.rejectReason = "";
            this.dialogRef.close();
            window.location.reload();
            // this.location.back();
          });
        },
          (error) => {
            Swal.fire("Error", `${error.error.message}`, 'error');
          })
      }
    } else {
      Swal.fire("Error", 'Invalid Approve Amount', 'error');
      this.amountApprove = "";
    }
  }

  submitRejectReason() {
    let payload = {
      user_id: this.userId,
      payment_id: this.payment_id,
      status: "3",
      payment_rejected_reason: this.rejectReason,
    }

    if (this.rejectReason !== "" && this.rejectReason !== undefined) {
      this.adminService.paymentUpdate(payload).subscribe((res: any) => {
        Swal.fire('Success', 'Rejection Reason Submitted Successfully', 'success').then(() => {
          this.showRejectCard = false;
          this.showApproveCard = false;
          this.amountApprove = "";
          this.rejectReason = "";
          // this.location.back();
          this.dialogRef.close();
          window.location.reload();
        });
      },
        (error) => {
          Swal.fire("Error", `${error.error.message}`, 'error');
        })
    } else if (this.rejectReason !== "" || this.rejectReason !== undefined) {
      Swal.fire("Error", 'Please Enter Rejection Reason', 'error');
    }
  }

  closeApproveCard() {
    this.showApproveCard = false;
    this.amountApprove = "";
    this.paymentRemark = "";
  }

  closeRejectCard() {
    this.showRejectCard = false;
    this.rejectReason = "";
  }
}
